export const checkPermission = (action, userLogged, branchOffice) => {
  if (
    userLogged &&
    userLogged.typeOfUser === 'admin' &&
    !['cucicba', 'matriculados', 'stats'].includes(action)
  ) {
    switch (action) {
      case 'Properties': {
        if (!userLogged.realEstateId) return false;
        break;
      }

      case 'Projects': {
        if (!userLogged.realEstateId) return false;
        break;
      }

      case 'Notifications': {
        if (!userLogged.realEstateId) return false;
        break;
      }

      case 'Information': {
        if (!userLogged.realEstateId) return false;
        break;
      }

      case 'Shared': {
        if (!userLogged.realEstateId) return false;
        break;
      }

      case 'Users': {
        if (!userLogged.realEstateId) return false;
        break;
      }

      case 'Roles': {
        if (!userLogged.realEstateId) return false;
        break;
      }

      case 'Integracion': {
        if (!userLogged.realEstateId) return false;
        break;
      }
    }

    return true;
  } else if (
    userLogged &&
    userLogged.typeOfUser === 'collab' &&
    userLogged.roles &&
    userLogged.roles.length
  ) {
    const { roles } = userLogged;
    switch (action) {
      //Case NavBar vertical labels
      case 'Properties': {
        const seePropertiesLabel = roles.map(
          ({ branch_office_id, permissions }) => {
            if (!branchOffice || branchOffice === branch_office_id) {
              return permissions.some(perm => perm.group === 'Propiedad');
            } else {
              return false;
            }
          }
        );
        return seePropertiesLabel.some(perm => perm === true);
      }
      case 'Permissions': {
        const seePermissionsLabel = roles.map(
          ({ branch_office_id, permissions }) => {
            if (!branchOffice || branchOffice === branch_office_id) {
              return permissions.some(
                perm => perm.group === 'Roles' || perm.group === 'Usuarios'
              );
            } else {
              return false;
            }
          }
        );
        return seePermissionsLabel.some(perm => perm === true);
      }
      //Case de usuarios
      case 'Users': {
        const usersPermissionFound = roles.map(
          ({ branch_office_id, permissions }) => {
            if (!branchOffice || branchOffice === branch_office_id) {
              return permissions.some(perm => perm.group === 'Usuarios');
            } else {
              return false;
            }
          }
        );
        return usersPermissionFound.some(perm => perm === true);
      }
      case 'Create users': {
        const usersPermissionFound = roles.map(
          ({ branch_office_id, permissions }) => {
            if (!branchOffice || branchOffice === branch_office_id) {
              return permissions.some(perm => perm.key === 'usuarios.crear');
            } else {
              return false;
            }
          }
        );
        return usersPermissionFound.some(perm => perm === true);
      }
      case 'Edit users': {
        const usersPermissionFound = roles.map(
          ({ branch_office_id, permissions }) => {
            if (!branchOffice || branchOffice === branch_office_id) {
              return permissions.some(perm => perm.key === 'usuarios.editar');
            } else {
              return false;
            }
          }
        );
        return usersPermissionFound.some(perm => perm === true);
      }
      case 'Delete users': {
        const usersPermissionFound = roles.map(
          ({ branch_office_id, permissions }) => {
            if (!branchOffice || branchOffice === branch_office_id) {
              return permissions.some(perm => perm.key === 'usuarios.delete');
            } else {
              return false;
            }
          }
        );
        return usersPermissionFound.some(perm => perm === true);
      }
      //Case de roles
      case 'Roles': {
        const rolesPermissionFound = roles.map(
          ({ branch_office_id, permissions }) => {
            if (!branchOffice || branchOffice === branch_office_id) {
              return permissions.some(perm => perm.group === 'Roles');
            } else {
              return false;
            }
          }
        );
        return rolesPermissionFound.some(perm => perm === true);
      }
      case 'Create roles': {
        const usersPermissionFound = roles.map(
          ({ branch_office_id, permissions }) => {
            if (!branchOffice || branchOffice === branch_office_id) {
              return permissions.some(perm => perm.key === 'roles.crear');
            } else {
              return false;
            }
          }
        );
        return usersPermissionFound.some(perm => perm === true);
      }
      case 'Edit roles': {
        const usersPermissionFound = roles.map(
          ({ branch_office_id, permissions }) => {
            if (!branchOffice || branchOffice === branch_office_id) {
              return permissions.some(perm => perm.key === 'roles.crear');
            } else {
              return false;
            }
          }
        );
        return usersPermissionFound.some(perm => perm === true);
      }
      case 'Delete roles': {
        const usersPermissionFound = roles.map(
          ({ branch_office_id, permissions }) => {
            if (!branchOffice || branchOffice === branch_office_id) {
              return permissions.some(perm => perm.key === 'roles.crear');
            } else {
              return false;
            }
          }
        );
        return usersPermissionFound.some(perm => perm === true);
      }
      //Case de mensajes
      case 'Messages': {
        const messagesPermissionFound = roles.map(
          ({ branch_office_id, permissions }) => {
            if (!branchOffice || branchOffice === branch_office_id) {
              return permissions.some(perm => perm.group === 'Mensajeria');
            } else {
              return false;
            }
          }
        );
        return messagesPermissionFound.some(perm => perm === true);
      }
      case 'See properties': {
        const seePropertiesPermissionFound = roles.map(
          ({ branch_office_id, permissions }) => {
            if (!branchOffice || branchOffice === branch_office_id) {
              return permissions.some(perm => perm.key === 'propiedad.ver');
            } else {
              return false;
            }
          }
        );
        return seePropertiesPermissionFound.some(perm => perm === true);
      }

      //Case de Propiedades
      case 'Create properties': {
        const createPropertiesPermissionFound = roles.map(
          ({ branch_office_id, permissions }) => {
            if (!branchOffice || branchOffice === branch_office_id) {
              return permissions.some(perm => perm.key === 'propiedad.crear');
            } else {
              return false;
            }
          }
        );
        return createPropertiesPermissionFound.some(perm => perm === true);
      }
      case 'Edit properties': {
        const editPropertiesPermissionFound = roles.map(
          ({ branch_office_id, permissions }) => {
            if (!branchOffice || branchOffice === branch_office_id) {
              return permissions.some(perm => perm.key === 'propiedad.editar');
            } else {
              return false;
            }
          }
        );
        return editPropertiesPermissionFound.some(perm => perm === true);
      }
      case 'Delete properties': {
        const deletePropertiesPermissionFound = roles.map(
          ({ branch_office_id, permissions }) => {
            if (!branchOffice || branchOffice === branch_office_id) {
              return permissions.some(
                perm => perm.key === 'propiedad.eliminar'
              );
            } else {
              return false;
            }
          }
        );
        return deletePropertiesPermissionFound.some(perm => perm === true);
      }
      case 'Shared': {
        const sharePropertiesPermissionFound = roles.map(
          ({ branch_office_id, permissions }) => {
            if (!branchOffice || branchOffice === branch_office_id) {
              return permissions.some(
                perm => perm.key === 'propiedad.acceso-compartidos'
              );
            } else {
              return false;
            }
          }
        );
        return sharePropertiesPermissionFound.some(perm => perm === true);
      }
      // Case de Integración

      case 'Integrations': {
        const integracionPermissionFound = roles.map(
          ({ branch_office_id, permissions }) => {
            if (!branchOffice || branchOffice === branch_office_id) {
              return permissions.some(perm => perm.group === 'Integracion');
            } else {
              return false;
            }
          }
        );
        return integracionPermissionFound.some(perm => perm === true);
      }

      // Case de Mercado Libre
      case 'Mercado Libre': {
        const integracionPermissionFound = roles.map(
          ({ branch_office_id, permissions }) => {
            if (!branchOffice || branchOffice === branch_office_id) {
              return permissions.some(perm => perm.group === 'Mercado Libre');
            } else {
              return false;
            }
          }
        );
        return integracionPermissionFound.some(perm => perm === true);
      }

      case 'Alerts': {
        const alertasPermissionFound = roles.map(
          ({ branch_office_id, permissions }) => {
            if (!branchOffice || branchOffice === branch_office_id) {
              return permissions.some(perm => perm.group === 'Alertas');
            } else {
              return false;
            }
          }
        );
        return alertasPermissionFound.some(perm => perm === true);
      }
      case 'Statistics': {
        const estadisticasPermissionFound = roles.map(
          ({ branch_office_id, permissions }) => {
            if (!branchOffice || branchOffice === branch_office_id) {
              return permissions.some(perm => perm.group === 'Estadisticas');
            } else {
              return false;
            }
          }
        );
        return estadisticasPermissionFound.some(perm => perm === true);
      }
      case 'Notifications': {
        return true;
      }
    }
  } else if (userLogged && userLogged.typeOfUser === 'cucicba') {
    switch (action) {
      case 'Statistics':
      case 'matriculados':
      case 'cucicba':
        return true;
      case 'Notifications':
      default:
        return false;
    }
  } else if (userLogged && userLogged.typeOfUser === 'stats') {
    switch (action) {
      case 'Statistics':
        return true;
      default:
        return false;
    }
  }
};
